import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { DocumentPendingStaffApproval, InvalidDocument } from '../../../../../../../../models/inbox';
import { dateStringFromISO8601, timeStringFromISO8601 } from '../../../../../../../../utils';
import { AccountService } from '../../../../../../../../services/account/account.service';
import { InboxService } from '../../../../../../../../services/inbox/inbox.service';

@Component({
  selector: 'app-view-dismissed-document-pending-staff-approval-modal',
  templateUrl: './view-dismissed-document-pending-staff-approval-modal.component.html',
  styleUrls: ['./view-dismissed-document-pending-staff-approval-modal.component.css']
})
export class ViewDismissedDocumentPendingStaffApprovalModalComponent implements OnInit {

  @Input() documentId: string;

  public document: DocumentPendingStaffApproval;

  public loadingDocument = false;
  public documentNotFound = false;
  public serverError: number = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public dateStringFromISO8601 = dateStringFromISO8601;
  public timeStringFromISO8601 = timeStringFromISO8601;

  constructor(
    public activeModal: NgbActiveModal,
    private accountService: AccountService,
    private inboxService: InboxService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }
    this.loadDocument();
  }

  private loadDocument() {
    this.loadingDocument = true;

    this.inboxService
      .getDocumentPendingStaffApprovalInboxItem(this.documentId)
      .then(document => {
        this.document = document;
      })
      .catch(reason => {
        if (reason.status === 404) {
          this.documentNotFound = true;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingDocument = false; });
  }

}
